export default "__VITE_ASSET__048a28f2__"